import { useMemo } from "react";
import useCustomEffect from "../../../../../../hooks/useCustomEffect";
import SaltoOpenLockFormView from "./SaltoOpenLockFormView";

function SaltoOpenLockForm({
  relations,
  fetchRelation,
  selectedStep,
  selectedStepIndex,
  setFlowData,
  submitError,
}) {
  const saltoLockLabels = useMemo(
    () =>
      relations?.salto_resources?.data?.locks?.reduce((acc, saltoLock) => {
        acc[saltoLock.id] = saltoLock.label;
        return acc;
      }, {}) ?? {},
    [relations?.salto_resources],
  );

  /**
   * This effect will fetch the salto config relation on mount.
   */
  useCustomEffect(() => {
    fetchRelation("salto_config");
    fetchRelation("salto_resources");
  }, []);

  /**
   * This method will handle the on lock change event
   * @param {int} saltoLockId
   */
  function onLockChange(saltoLockId) {
    setFlowData((prev) => ({
      ...prev,
      steps: prev.steps.map((step) => {
        if (step.id === selectedStep.id) {
          return {
            ...step,
            salto_lock_id: saltoLockId,
          };
        }
        return step;
      }),
    }));
  }

  return (
    <SaltoOpenLockFormView
      relations={relations}
      selectedStep={selectedStep}
      selectedStepIndex={selectedStepIndex}
      saltoLockLabels={saltoLockLabels}
      onLockChange={onLockChange}
      submitError={submitError}
    />
  );
}

export default SaltoOpenLockForm;
